import React, { Children } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export function ReservationDetail() {
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 Nov 2025',
      checkOut: '11 Nov 2025',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.my',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Maldivan escape early and enjoy the added luxury of a complimentary round-trip seaplane transfer from Malé to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: '$1.00',
      serviceCharge: '$0.10'
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-5345">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-5346">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-5347">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-5348" />
          <span data-id="element-5349">Reservation Details</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-5350">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-5351">
          <div className="flex justify-between items-center" data-id="element-5352">
            <h2 className="text-xl font-bold" data-id="element-5353">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-5354">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-5355">
                Confirmed
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-5356">
                Resend confirmation email
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-5357">
          <div className="p-6 border-r border-gray-200" data-id="element-5358">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-5359">Date</h3>
            <p className="text-gray-900 font-medium" data-id="element-5360">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-5361">
              {reservation.date.nights} Nights
            </p>
          </div>
          <div className="p-6" data-id="element-5362">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-5363">
              Guests & Rooms
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-5364">
              {reservation.guests.adults} Adults, {reservation.guests.children}{' '}
              Children, {reservation.guests.infants} Infants
            </p>
            <p className="text-sm text-gray-500" data-id="element-5365">
              {reservation.guests.rooms} Room
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-5366">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5367">Booking Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5368">
            <div data-id="element-5369">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5370">Booking ID</p>
              <p className="text-sm text-gray-900" data-id="element-5371">{reservation.booking.id}</p>
            </div>
            <div data-id="element-5372">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5373">Transaction ID</p>
              <p className="text-sm text-gray-900" data-id="element-5374">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-5375">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5376">Hotel</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5377">
            <div data-id="element-5378">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5379">Name</p>
              <p className="text-sm text-gray-900" data-id="element-5380">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-5381">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5382">Hotel ID</p>
              <p className="text-sm text-gray-900" data-id="element-5383">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-5384">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5385">Room Type</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5386">
            <div data-id="element-5387">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5388">Name</p>
              <p className="text-sm text-gray-900" data-id="element-5389">{reservation.room.name}</p>
            </div>
            <div data-id="element-5390">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5391">View</p>
              <p className="text-sm text-gray-900" data-id="element-5392">{reservation.room.view}</p>
            </div>
            <div data-id="element-5393">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5394">Category</p>
              <p className="text-sm text-gray-900" data-id="element-5395">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-5396">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5397">Guest Information</h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-5398">
            <h4 className="text-base font-medium mb-4" data-id="element-5399">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5400">
              <div data-id="element-5401">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5402">Email</p>
                <p className="text-sm text-gray-900" data-id="element-5403">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-5404">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5405">Phone number</p>
                <p className="text-sm text-gray-900" data-id="element-5406">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-5407">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5408">Passport number</p>
                <p className="text-sm text-gray-900" data-id="element-5409">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-5410">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5411">Date of birth</p>
                <p className="text-sm text-gray-900" data-id="element-5412">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-5413">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5414">Nationality</p>
                <p className="text-sm text-gray-900" data-id="element-5415">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-5416">
                <p className="text-sm text-gray-500 mb-1" data-id="element-5417">Special Requests</p>
                <p className="text-sm text-gray-900" data-id="element-5418">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-5419">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5420">Rate Details</h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-5421">
            <div data-id="element-5422">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5423">Rate Name</p>
              <p className="text-sm text-gray-900" data-id="element-5424">{reservation.rate.name}</p>
            </div>
            <div data-id="element-5425">
              <p className="text-sm text-gray-500 mb-1" data-id="element-5426">Description</p>
              <p className="text-sm text-gray-900" data-id="element-5427">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-5428">
          <h3 className="text-sm font-semibold mb-4" data-id="element-5429">Price Breakdown</h3>
          <div className="space-y-3" data-id="element-5430">
            <div className="flex justify-between" data-id="element-5431">
              <p className="text-sm text-gray-500" data-id="element-5432">Subtotal</p>
              <p className="text-sm text-gray-900" data-id="element-5433">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-5434">
              <p className="text-sm text-gray-500" data-id="element-5435">Service charge</p>
              <p className="text-sm text-gray-900" data-id="element-5436">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-5437">
              <p className="text-sm font-medium" data-id="element-5438">Total</p>
              <p className="text-sm font-bold" data-id="element-5439">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}